import { makeStyles, Typography } from '@ellucian/react-design-system/core';
import { spacing40 } from '@ellucian/react-design-system/core/styles/tokens';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { CONSTANTS } from '../Helpers/Configuration';
const useStyles = makeStyles(theme => ({
    autosaveStatus: {
        marginLeft: 'auto',
        margin: `${spacing40} ${spacing40} 0 auto`,
    },
    [theme.breakpoints.down('sm')]: {
        autosaveStatus: {
            margin: '.75rem 0 0',
        },
    },
}));
const selectAutosaveStatus = state => (state.settings?.autosave?.status ?? CONSTANTS.autosaveStatuses.ERROR);
const AutosaveStatus = () => {
    const classes = useStyles();
    const autosaveStatus = useSelector(selectAutosaveStatus);
    return (
        <div className={classes.autosaveStatus}>
            <Typography>
                <FormattedMessage id={`applicationFormAutosave${autosaveStatus}`} />
            </Typography>
        </div>
    );
};
export default AutosaveStatus;
